import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getLocalText } from '@/utilities/language';
import { getRealShowOption, getRealShowLine, resetAnwsers } from '@/utilities/quest';
import { randomArray, randomComp, randomShowOptions } from '@/utilities/common';
var defaultAnswer = {
  selected: {},
  text: {},
  type: 'matrix'
};
var deviceWidth = document.body.clientWidth;
var Matrix = /*#__PURE__*/function (_Component) {
  _inherits(Matrix, _Component);
  function Matrix(props) {
    var _this;
    _classCallCheck(this, Matrix);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Matrix).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setIsFocus", function (isFocus) {
      _this.setState({
        isFocus: isFocus
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var question = _this.props.question;
      var custom = question.custom;
      var lines = _this.state.lines;
      var selected = answer.selected,
        text = answer.text;
      var min = custom.min,
        max = custom.max,
        options = custom.options,
        other = custom.other;
      var realMin = min || +question.required;
      if (question.required && Object.values(answer.selected).filter(function (el) {
        return Array.isArray(el) && el.length || !Array.isArray(el) && el;
      }).length !== lines.length) {
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          var tmp = answer.selected[line.id];
          if (!tmp || Array.isArray(tmp) && !tmp.length) {
            callback("".concat(getLocalText('SingleChoice.Selected'), "===").concat(line.id));
            return;
          }
        }
      }
      for (var _i = 0; _i < lines.length; _i++) {
        var _line = lines[_i];
        var _tmp = answer === null || answer === void 0 ? void 0 : answer.selected[_line.id];
        if ((_tmp === null || _tmp === void 0 ? void 0 : _tmp.length) && (realMin && _tmp.length < realMin || max && _tmp.length > max)) {
          callback("".concat(getLocalText('MultiChoice.min.or.max', realMin, max || options.length + +(other.status !== 0)), "===").concat(_line.id));
          return;
        }
      }
      var otherRequired = custom.other.status === 2;
      if (otherRequired) {
        var couldReturn = false;
        Object.keys(selected).forEach(function (key) {
          if (couldReturn) {
            return;
          }
          if (selected[key].includes('other') && (text[key] === undefined || text[key] === '')) {
            callback(getLocalText('SingleChoice.otherText'));
            couldReturn = true;
          }
        });
        if (couldReturn) {
          return;
        }
      }
      callback();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "retrieveFunc", function (question, funcName) {
      var id = question.id || 'unknown-form-item';
      var isSingleMatrix = question.custom.isSingleMatrix;
      var _this$getFormAnswer = _this.getFormAnswer(id),
        onChange = _this$getFormAnswer.onChange,
        formAnswer = _this$getFormAnswer.formAnswer;
      if (funcName === 'selected') {
        return function (lineSelected, lineKey) {
          return onChange(_this.getSelectedChange(lineSelected, lineKey, formAnswer, isSingleMatrix));
        };
      } else if (funcName === 'text') {
        return function (lineText, lineKey) {
          var newText = _this.getOtherTextChange(lineText, lineKey, formAnswer, isSingleMatrix);
          onChange(newText);
        };
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSplitQuestion", function (_ref, device) {
      var isScaleMatrix = _ref.isScaleMatrix,
        _ref$transpose = _ref.transpose,
        transpose = _ref$transpose === void 0 ? false : _ref$transpose,
        _ref$splitMode = _ref.splitMode,
        splitMode = _ref$splitMode === void 0 ? 'auto' : _ref$splitMode;
      var _this$state = _this.state,
        realShowOptions = _this$state.realShowOptions,
        lines = _this$state.lines;
      var splitModeNew = splitMode;
      if (isScaleMatrix) splitModeNew = 'disable';
      var optionsLength = (transpose ? lines : realShowOptions).reduce(function (sum, el) {
        return sum + el.text.html2Text().length;
      }, 0);
      var splitQuestion = optionsLength * 13 > deviceWidth - 30 || device === 'mobile' && realShowOptions.length > 8;
      return splitModeNew === 'disable' ? false : splitModeNew === 'always' ? true : splitQuestion;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getError", function (id) {
      var getFieldError = _this.props.form.getFieldError;
      var errorSelected;
      var errorText;
      var errorLine;
      var error = getFieldError(id);
      if (error) {
        if (error[0] === getLocalText('SingleChoice.otherText')) {
          var _error = _slicedToArray(error, 1);
          errorText = _error[0];
        } else {
          var _error$0$split = error[0].split('===');
          var _error$0$split2 = _slicedToArray(_error$0$split, 2);
          errorSelected = _error$0$split2[0];
          errorLine = _error$0$split2[1];
        }
      }
      return {
        selected: errorSelected,
        text: errorText,
        errorLine: errorLine
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFormAnswer", function (id) {
      var _this$props = _this.props,
        getFieldProps = _this$props.form.getFieldProps,
        _this$props$answer = _this$props.answer,
        answer = _this$props$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props$answer;
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            validator: _this.validator
          }]
        }),
        onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      return {
        onChange: onChange,
        formAnswer: formAnswer
      };
    });
    var _question = props.question,
      answers = props.answers,
      form = props.form;
    var _custom = _question.custom;
    var _options = _custom.options,
      _lines = _custom.lines,
      _isScaleMatrix = _custom.isScaleMatrix;
    var linesKeys = _lines.map(function (el) {
      return el.id;
    });
    var thisLines = getRealShowLine({
      question: _question,
      answers: answers
    });
    _this.state = {
      options: _options,
      lines: thisLines,
      linesKeys: linesKeys,
      realShowOptions: getRealShowOption({
        question: _question,
        answers: answers
      }),
      realShowLines: thisLines,
      optionsBack: getRealShowOption({
        question: _question,
        answers: answers
      }),
      isFocus: false,
      setShowLines: _custom.randomLine && _custom.showOptionsNum && _custom.showOptionsNum > 0,
      setShowOptions: !_isScaleMatrix && (_custom.random || _custom.reverse) && _custom.showMatrixOptionsNum && _custom.showMatrixOptionsNum > 0
    };
    if (!_isScaleMatrix && (_custom.random || _custom.reverse)) {
      // 随机选项排序
      if (_custom.random) {
        _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions));
      } else {
        var actuallyReverse = Math.random() >= 0.5;
        if (actuallyReverse) {
          _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions), 'reverse');
        }
      }
      // 设置随机显示X个
      if (_this.state.setShowOptions) {
        _this.state.realShowOptions = randomShowOptions(_toConsumableArray(_this.state.realShowOptions), _custom.showMatrixOptionsNum, _custom.random ? 'random' : 'reverse');
        props.form.setFieldsValue(_defineProperty({}, _question.id, {
          type: 'matrix',
          selected: [],
          text: ''
        }));
      }
    }
    if (_custom.randomLine) {
      // 题目随机排序
      _this.state.lines = randomArray(_toConsumableArray(_this.state.lines));
      // 设置随机显示X个
      if (_this.state.setShowLines) {
        _this.state.lines = randomShowOptions(_toConsumableArray(_this.state.lines), _custom.showOptionsNum, 'random');
        props.form.setFieldsValue(_defineProperty({}, _question.id, {
          type: 'matrix',
          selected: [],
          text: ''
        }));
      }
    }
    var lineIds = thisLines.map(function (el) {
      return el.id;
    });
    var preThisAnswers = answers[_question.id];
    var thisSelected = (preThisAnswers || {}).selected;
    // 删掉多余lines的答案
    if (!isEmpty(thisSelected)) {
      var thisAnswers = {};
      var tmp = _objectSpread({}, preThisAnswers);
      lineIds.map(function (id) {
        thisAnswers[id] = thisSelected[id] ? thisSelected[id] : [];
        return id;
      });
      tmp.selected = thisAnswers;
      if (form.getFieldValue(_question.id)) {
        form.setFieldsValue(_defineProperty({}, _question.id, tmp));
      }
    }
    return _this;
  }
  _createClass(Matrix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        question = _this$props2.question,
        answers = _this$props2.answers;
      try {
        var _answers$question$id;
        var selected = (answers === null || answers === void 0 ? void 0 : (_answers$question$id = answers[question.id]) === null || _answers$question$id === void 0 ? void 0 : _answers$question$id.selected) || {};
        var _this$state2 = this.state,
          realShowOptions = _this$state2.realShowOptions,
          realShowLines = _this$state2.realShowLines;
        if (Object.keys(selected).length) {
          var newSelected = resetAnwsers({
            type: 'matrix',
            question: question,
            answers: answers,
            realShowOptions: realShowOptions,
            realShowLines: realShowLines
          });
          this.props.form.setFieldsValue(_defineProperty({}, question.id, {
            type: 'matrix',
            selected: newSelected,
            text: ''
          }));
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQ = prevProps.question;
      var nextQ = this.props.question;
      var _this$state3 = this.state,
        realShowOptions = _this$state3.realShowOptions,
        realShowLines = _this$state3.realShowLines; // 如果选项变了 就清空答案
      if (prevState.realShowOptions !== realShowOptions && !window.isReport) {
        this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
          type: 'matrix',
          selected: {},
          text: ''
        }));
      }
      if (prevState.realShowLines !== realShowLines && !window.isReport) {
        try {
          var selected = resetAnwsers({
            type: 'matrix',
            question: nextQ,
            answers: this.props.answers,
            realShowOptions: realShowOptions,
            realShowLines: realShowLines
          });
          this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
            type: 'matrix',
            selected: selected,
            text: ''
          }));
        } catch (error) {
          console.error(error);
        }
      }

      // 判断是否修改了options， 但是broadcastchannell始终是深拷贝传递。所以这里不能比较地址了。
      if (JSON.stringify(nextQ.custom.options) !== JSON.stringify(prevQ.custom.options)) {
        if (nextQ.custom.random) {
          // eslint-disable-next-line
          this.setState({
            options: nextQ.custom.options.slice().sort(randomComp)
          });
        } else {
          // eslint-disable-next-line
          this.setState({
            options: nextQ.custom.options
          });
        }
      }
      if (JSON.stringify(nextQ.custom.lines) !== JSON.stringify(prevQ.custom.lines)) {
        if (nextQ.custom.random) {
          // eslint-disable-next-line
          this.setState({
            lines: nextQ.custom.lines.slice().sort(randomComp)
          });
        } else {
          // eslint-disable-next-line
          this.setState({
            lines: nextQ.custom.lines
          });
        }
      }
    }
  }, {
    key: "getSelectedChange",
    value: function getSelectedChange(lineSelected, lineKey, answer, isSingleMatrix) {
      var _JSON$parse = JSON.parse(JSON.stringify(answer)),
        selected = _JSON$parse.selected,
        text = _JSON$parse.text;
      var linesKeys = this.state.linesKeys;
      Object.keys(selected).forEach(function (key) {
        if (!linesKeys.includes(key)) {
          delete selected[key];
        }
      });
      selected[lineKey] = _toConsumableArray(lineSelected);
      if (lineSelected.length === 0) {
        delete selected[lineKey];
      }
      return {
        type: 'matrix',
        selected: _objectSpread({}, selected),
        text: text,
        isSingleMatrix: isSingleMatrix
      };
    }
  }, {
    key: "getOtherTextChange",
    value: function getOtherTextChange(lineText, lineKey, answer, isSingleMatrix) {
      var selected = answer.selected,
        text = answer.text;
      if (!selected[lineKey]) {
        selected[lineKey] = ['other'];
      } else if (!selected[lineKey].includes('other')) {
        selected[lineKey].push('other');
      }
      text[lineKey] = lineText;
      return {
        type: 'matrix',
        selected: selected,
        text: text,
        isSingleMatrix: isSingleMatrix
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        question = _this$props3.question,
        _this$props3$device = _this$props3.device,
        device = _this$props3$device === void 0 ? 'pc' : _this$props3$device;
      var _this$state4 = this.state,
        realShowOptions = _this$state4.realShowOptions,
        lines = _this$state4.lines;
      var _question$custom = question.custom,
        isSingleMatrix = _question$custom.isSingleMatrix,
        _question$custom$tran = _question$custom.transpose,
        transpose = _question$custom$tran === void 0 ? false : _question$custom$tran,
        isScaleMatrix = _question$custom.isScaleMatrix,
        styleType = _question$custom.styleType,
        random = _question$custom.random,
        min = _question$custom.min,
        max = _question$custom.max,
        options = _question$custom.options,
        other = _question$custom.other;
      var splitQuestion = this.getSplitQuestion(question.custom, device);
      var id = question.id || 'unknown-form-item';
      var params = {
        options: realShowOptions,
        isRandomOpts: random,
        splitQuestion: splitQuestion,
        lines: lines,
        formAnswer: this.getFormAnswer(id).formAnswer,
        isScaleMatrix: isScaleMatrix,
        isSingleMatrix: isSingleMatrix,
        styleType: styleType,
        transpose: transpose,
        error: this.getError(id),
        onChange: {
          selected: this.retrieveFunc(question, 'selected'),
          text: this.retrieveFunc(question, 'text')
        },
        min: min || +question.required,
        max: max || options.length + +(other.status !== 0),
        realMin: min,
        realMax: max
      };
      return React.createElement("div", {
        onFocus: function onFocus() {
          return _this2.setIsFocus(true);
        },
        onBlur: function onBlur() {
          return _this2.setIsFocus(false);
        },
        className: device === 'mobile' ? 'matrix-line' : ''
      }, this.props.children(params));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var question = nextProps.question,
        answers = nextProps.answers;
      var custom = question.custom;
      var realShowOptions = getRealShowOption({
        question: question,
        answers: answers
      });
      if (custom.random && !custom.isScaleMatrix) {
        realShowOptions = randomArray(_toConsumableArray(realShowOptions));
      }
      var realShowLines = getRealShowLine({
        question: question,
        answers: answers
      });
      var newState = null;
      window.allQuestions.find(function (el) {
        return el.id === question.id;
      }).custom.realShowOptions = realShowOptions;
      if (realShowOptions.length !== state.optionsBack.length || realShowOptions.some(function (el) {
        return !state.optionsBack.find(function (item) {
          return item.id === el.id;
        });
      }) || realShowOptions.some(function (el) {
        return el.text !== state.optionsBack.find(function (item) {
          return item.id === el.id;
        }).text;
      })) {
        var realOptions = _toConsumableArray(realShowOptions);
        if (custom.random && !custom.isScaleMatrix) {
          realShowOptions = randomArray(_toConsumableArray(realShowOptions));
        }
        if (!custom.isScaleMatrix && (custom.random || custom.reverse) && state.setShowOptions) {
          realShowOptions = randomShowOptions(_toConsumableArray(realShowOptions), custom.showMatrixOptionsNum, custom.random ? 'random' : 'reverse');
          nextProps.form.setFieldsValue(_defineProperty({}, question.id, {
            type: 'matrix',
            selected: [],
            text: ''
          }));
        }
        newState = {
          realShowOptions: realShowOptions,
          optionsBack: realOptions
        };
      }
      if (realShowLines.length !== state.realShowLines.length || realShowLines.some(function (el) {
        return !state.realShowLines.find(function (item) {
          return item.id === el.id;
        });
      })) {
        var realLines = _toConsumableArray(realShowLines);
        if (custom.randomLine) {
          realShowLines = randomArray(_toConsumableArray(realShowLines));
          if (state.setShowLines) {
            realShowLines = randomShowOptions(_toConsumableArray(realShowLines), custom.showOptionsNum, 'random');
            nextProps.form.setFieldsValue(_defineProperty({}, question.id, {
              type: 'matrix',
              selected: [],
              text: ''
            }));
          }
        }
        newState = _objectSpread({}, newState, {
          lines: realShowLines,
          realShowLines: realLines
        });
      }
      return newState;
    }
  }]);
  return Matrix;
}(Component);
export { Matrix as default };